import { Type } from '@sinclair/typebox';
import { AuditStatusSchema, BooleanTypeCheckSchema, PercentTypeCheckSchema, ValueCheckSchema, } from '../audit-status.js';
export const OverAllChecksSchema = Type.Object({
    overall: AuditStatusSchema,
    safeCount: Type.Number(),
    warningCount: Type.Number(),
    dangerCount: Type.Number(),
});
export const BasePoolAuditCheckSchema = Type.Object({
    isMintable: BooleanTypeCheckSchema,
    isFreezable: BooleanTypeCheckSchema,
    updateAuthority: ValueCheckSchema,
    top10HoldersPercentage: PercentTypeCheckSchema,
    lpBurned: PercentTypeCheckSchema,
    ownerTokenBalance: PercentTypeCheckSchema,
});
export const SolPoolAuditSchema = Type.Object({
    overAllChecks: OverAllChecksSchema,
    checks: Type.Intersect([
        BasePoolAuditCheckSchema,
        Type.Object({
            isTokenDataMutable: BooleanTypeCheckSchema,
        }),
    ]),
    meta: Type.Object({
        lpCreatorAddress: Type.String(),
        deployerAddress: Type.String(),
    }),
});
export const EvmPoolAuditSchema = Type.Object({
    overAllChecks: OverAllChecksSchema,
    checks: BasePoolAuditCheckSchema,
    meta: Type.Object({
        lpCreatorAddress: Type.String(),
        deployerAddress: Type.String(),
    }),
});
export const PoolAuditSchema = Type.Union([
    SolPoolAuditSchema,
    EvmPoolAuditSchema,
]);
//# sourceMappingURL=pool-audit.js.map